import React, { useEffect, useState } from "react";
import "../style/providerListing-style.css";
// import ProviderHeader from "../../provider-header/components/index";
import IC_logo from "../../../../assets/images/1744877067.jpg";
import ProviderFilter from "../../provider-filter/components/index";
import Pagination from "../../../../pagination/components";
import { useDispatch, useSelector } from "react-redux";
import { getProviderList } from "../slice/listingSlice";
import { useNavigate } from 'react-router-dom';

const ProviderListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { providers, loading, error, pagination } = useSelector((state) => state.providerList);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    keyword: "",
    status: ""
  });

  useEffect(() => {
      dispatch(getProviderList({ page, filters }));
    }, [dispatch, page, filters]);
  
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(1); 
  };

  const handleClearFilters = () => {
    setFilters({ keyword: "", status: "" });
    setPage(1);
  };

  console.log("providers", providers);

// const providers = (data[0]?.data) || [];

  return (
    <>
    {/* <ProviderHeader /> */}
      <div className="provider-layout">
        <ProviderFilter
          filters={filters}
          onFilterChange={handleFilterChange}
          onClearFilters={handleClearFilters}
        />
        <div className="provider-listing">
          {providers.map((provider) => (
            <div key={provider.id} className="provider-card">
              <div className="provider-photo-wrapper">
                <a href="#">
                  <img src={IC_logo} alt={provider.company_name} className="provider-photo" />
                </a>
              </div>
              <div className="provider-details-main">
                <div className="provider-details">
                  <a className="provider_name" href="#">{provider.company_name}</a><br />
                  <p className="provider_location">
                    <i className="fa fa-location-arrow"></i> <b>Location:</b> {provider.address}
                  </p>
                  {/* <span>{provider.age} Yrs Height {provider.height}, </span>
                  <span>{provider.religion}</span> */}
                  <p> Status: {provider.status}</p>
                  <p><button type="button" className="btn_view_proifile">View Profile</button></p>
                  <p><button type="button" className="btn_chat" onClick={() => navigate(`/chat/provider/${provider.id}`)}><i className="fa fa-comment px-1"></i> Chat</button></p>
                </div>
                <div className="send-request-block">
                  <button type="button" className="btn_send_request">Send Request</button>
                </div>
              </div>
            </div>
          ))}
          <Pagination
        currentPage={page}
        totalPages={pagination.last_page || 0}
        onPageChange={handlePageChange}
      />
        </div>
        
      </div>
      
    </>
  );
};

export default ProviderListing;